export const staticMetaProps = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/novosti/`,
  seoTitle: 'ЦИАН - новости рынка недвижимости Москвы и России',
  seoDescription: `ЦИАН - новости рынка недвижимости в России.
    Новости об аренде и продаже квартир, офисов, домов и другой недвижимости. Новости о новостройках в вашем регионе`,
  seoKeywords: 'новости, недвижимость, информация, москва, россия, квартиры, офисы, помещения, дома',
});

const staticMetaPropsMarket = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/novosti/market/`,
  seoTitle: 'Новости рынка недвижимости - ЦИАН',
  seoDescription: `ЦИАН - самые свежие и актуальные новости рынка недвижимости.
    Информационные и аналитические статьи, обзоры, комментарии специалистов.`,
  seoKeywords: 'новости, рынок недвижимости, циан',
});

const staticMetaPropsCompany = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/novosti/company/`,
  seoTitle: 'Новости от застройщиков, агентств недвижимости и других компаний - ЦИАН',
  seoDescription: `ЦИАН - самые свежие и актуальные новости от застройщиков, агентств недвижимости и других компаний.
    Информационные и аналитические статьи, обзоры, комментарии специалистов.`,
  seoKeywords: 'новости, рынок недвижимости, циан, агентства недвижимости, застройщики',
});

export const staticMetaPropsArray = [{
    type: '',
    data: staticMetaProps,
  }, {
    type: 'market',
    data: staticMetaPropsMarket,
  }, {
    type: 'company',
    data: staticMetaPropsCompany,
  }];
